import LazyLoad from "vanilla-lazyload";
let lazyLoader;
export const imageLazyLoad = () => {
    if(!lazyLoader){
        lazyLoader = new LazyLoad({
            callback_loaded: function (el){
                el.classList.remove('lazy');
                el.parentElement.classList.remove('lazyPicture','lazyArticle');
                el.parentElement.parentElement.classList.remove('lazyPicture','lazyArticle');
            },
            cancel_on_exit: false
        })
    }else{
        lazyLoader.update();
    }
}